import {Directive, DOCUMENT, inject, OnDestroy, OnInit, PLATFORM_ID} from "@angular/core";
import {Router} from "@angular/router";
import {Subject} from "rxjs";
import {Meta, Title} from "@angular/platform-browser";
import {MatSnackBar} from "@angular/material/snack-bar";
import {environment} from "../../../environments/environment";

@Directive()
export abstract class PageBase implements OnInit, OnDestroy {
  protected router = inject(Router);
  protected titleService = inject(Title);
  protected metaService = inject(Meta);
  protected snackBar = inject(MatSnackBar);
  protected platformId = inject(PLATFORM_ID);
  protected document = inject(DOCUMENT); // Always safe to inject for DOM manipulation

  // A common pattern for cleaning up subscriptions
  protected destroy$ = new Subject<void>();

  protected pageTitle: string = "Бързи онлайн кредити от MiniZaem.bg – изгодни и прозрачни. - Minizaem.bg";
  protected metaDescription: string = "Вземи бърз кредит онлайн с 0% лихва или отстъпка от оскъпяването за броени минути.";
  protected metaKeywords: string = "заем, кредит, бърз кредит, кредити онлайн, онлайн заем, потребителски кредит, бърз заем, паричен заем, без поръчител, без доказване на доходи, без обезпечение, кредихоум, изи кредит, пари на заем, credit, бързи кредити, бързи заеми, ипотека, ипотечен кредит, пари на заем, кредит онлайн, zaem, kredit, pari online";
  protected metaRobots: string = "noindex,nofollow";


  ngOnInit(): void {
    if(environment.production){
      this.metaRobots = "index,follow";
    }
    this.applySEO();
    this.updateCanonicalUrl();
  }

  private applySEO() {
    this.titleService.setTitle(this.pageTitle);
    this.metaService.updateTag({name: 'description', content: this.metaDescription});
    this.metaService.updateTag({name: 'keywords', content: this.metaKeywords});
    this.metaService.updateTag({name: 'description', content: this.metaDescription});
    this.metaService.updateTag({name: 'robots', content: this.metaRobots});

    this.metaService.updateTag({name: 'og:description', content: this.metaDescription});
    this.metaService.updateTag({name: 'og:keywords', content: this.metaKeywords});
    this.metaService.updateTag({name: 'og:url', content: this.router.url});
  }

  private updateCanonicalUrl() {
    // 1. Extract path without query parameters or hashtag fragments
    const pathWithoutParams = this.router.url.split('?')[0].split('#')[0];

    // 2. Ensure we don't accidentally create double slashes (//) if router.url starts with /
    const baseDomain = environment.domain.endsWith('/')
      ? environment.domain.slice(0, -1)
      : environment.domain;

    const canonicalUrl = `${baseDomain}${pathWithoutParams}`;

    // 3. Update the OpenGraph meta URL property alongside it
    this.metaService.updateTag({ name: 'og:url', content: canonicalUrl });

    // 4. Query for an existing canonical link element or create a new one
    let link: HTMLLinkElement | null = this.document.querySelector("link[rel='canonical']");

    if (!link) {
      link = this.document.createElement('link');
      link.setAttribute('rel', 'canonical');
      this.document.head.appendChild(link);
    }

    // 5. Update the link href attribute
    link.setAttribute('href', canonicalUrl);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
